/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 4th 2022, 3:21:06 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { SERVICE_BUILDER_RELATIVE_URLS } from "service-builder/routes";
import { Link, useParams } from "react-router-dom";
import { useRouteMatch, resolveURLName } from "core/routes/utils";
import { useServiceBuilderContext } from "service-builder/providers";
import { OSDialogCloseButton } from "ui-widgets";

export const ServiceBuilderNavBar = () => {
  const routeMatch = useRouteMatch(Object.values(SERVICE_BUILDER_RELATIVE_URLS));
  let currentTab = routeMatch?.pattern?.path;

  const { formBuilderContext } = useServiceBuilderContext();
  const { currentFormConfiguration } = formBuilderContext;

  // Resolving the active tabs for form builder url based on the form type.
  if (currentTab === SERVICE_BUILDER_RELATIVE_URLS.serviceFormBuilder) {
    switch (currentFormConfiguration?.form_type) {
      case "application_form":
      case "general_form":
        currentTab = SERVICE_BUILDER_RELATIVE_URLS.submissionForms;
        break;
      case "registration_form":
        currentTab = SERVICE_BUILDER_RELATIVE_URLS.serviceRegistrationForms;
        break;
      case "review_form":
      case "payment_form":
      case "survey_form":
        currentTab = SERVICE_BUILDER_RELATIVE_URLS.serviceBuilderRoot;
        break;
    }
  }

  if (currentTab === SERVICE_BUILDER_RELATIVE_URLS.billingConfiguration)
    currentTab = SERVICE_BUILDER_RELATIVE_URLS.billingConfigurationsList;

  if (currentTab === SERVICE_BUILDER_RELATIVE_URLS.documentTemplate)
    currentTab = SERVICE_BUILDER_RELATIVE_URLS.documentTemplatesList;

  const { serviceId } = useParams();

  return (
    <Box className="os-service-builder-navbar" sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs value={currentTab}>
        <Tab
          label="Workflow"
          value={SERVICE_BUILDER_RELATIVE_URLS.serviceBuilderRoot}
          to={resolveURLName("serviceBuilderRoot", { serviceId })}
          component={Link}
        />

        <Tab
          label="Submission Forms"
          value={SERVICE_BUILDER_RELATIVE_URLS.submissionForms}
          to={resolveURLName("submissionForms", { serviceId })}
          component={Link}
        />

        <Tab
          label="Team Access"
          value={SERVICE_BUILDER_RELATIVE_URLS.teamAccess}
          to={resolveURLName("teamAccess", { serviceId })}
          component={Link}
        />

        <Tab
          label="Service Registration Forms"
          value={SERVICE_BUILDER_RELATIVE_URLS.serviceRegistrationForms}
          to={resolveURLName("serviceRegistrationForms", { serviceId })}
          component={Link}
        />

        <Tab
          label="Billing"
          value={SERVICE_BUILDER_RELATIVE_URLS.billingConfigurationsList}
          to={resolveURLName("billingConfigurationsList", { serviceId })}
          component={Link}
        />

        <Tab
          label="Document Templates"
          value={SERVICE_BUILDER_RELATIVE_URLS.documentTemplatesList}
          to={resolveURLName("documentTemplatesList", { serviceId })}
          component={Link}
        />

        <Tab
          label="Layouts"
          value={SERVICE_BUILDER_RELATIVE_URLS.layouts}
          to={resolveURLName("layouts", { serviceId })}
          component={Link}
        />

        <Tab
          label="Advanced Settings"
          value={SERVICE_BUILDER_RELATIVE_URLS.advancedSettings}
          to={resolveURLName("advancedSettings", { serviceId })}
          component={Link}
        />
      </Tabs>
      <Link to={resolveURLName("services")}>
        <OSDialogCloseButton onClick={(e) => {}} />
      </Link>
    </Box>
  );
};
